import { errorMessage, footnote, infoIcon, input, label, labelSide, labelContentSpanLeft, labelContentSpanRight, labelContentSpanTop, labelWrapperChildren, labelWrapChildren, labelWrapChildrenSide, valueWrapper, validationLabel, } from '../styles/legacy';
import { errorMessage as errorMessageCitron, footnote as footnoteCitron, infoIcon as infoIconCitron, input as inputCitron, label as labelCitron, labelSide as labelSideCitron, labelContentSpanLeft as labelContentSpanLeftCitron, labelContentSpanRight as labelContentSpanRightCitron, labelContentSpanTop as labelContentSpanTopCitron, labelWrapperChildren as labelWrapperChildrenCitron, labelWrapChildren as labelWrapChildrenCitron, labelWrapChildrenSide as labelWrapChildrenSideCitron, valueWrapper as valueWrapperCitron, validationLabel as validationLabelCitron, } from '../styles/citron';
import { citrusStyled } from '@citrus/runtime';
export var Input = citrusStyled.input('input', { legacy: input, citrus2022: inputCitron });
export var InfoIcon = citrusStyled.span('infoIcon', { legacy: infoIcon, citrus2022: infoIconCitron });
export var ErrorMessage = citrusStyled.span('errorMessage', {
    legacy: errorMessage,
    citrus2022: errorMessageCitron,
});
export var Footnote = citrusStyled.span('footnote', { legacy: footnote, citrus2022: footnoteCitron });
export var Label = citrusStyled.div('label', { legacy: label, citrus2022: labelCitron });
export var LabelSide = citrusStyled.div('labelSide', { legacy: labelSide, citrus2022: labelSideCitron });
export var LabelWrapChildren = citrusStyled.label('labelWrapChildren', {
    legacy: labelWrapChildren,
    citrus2022: labelWrapChildrenCitron,
});
export var LabelWrapChildrenSide = citrusStyled.label('labelWrapChildrenSide', {
    legacy: labelWrapChildrenSide,
    citrus2022: labelWrapChildrenSideCitron,
});
export var LabelWrapperChildren = citrusStyled.div('labelWrapperChildren', {
    legacy: labelWrapperChildren,
    citrus2022: labelWrapperChildrenCitron,
});
export var ValueWrapper = citrusStyled.div('valueWrapper', {
    legacy: valueWrapper,
    citrus2022: valueWrapperCitron,
});
export var CharacterCount = citrusStyled.div('footnote', { legacy: footnote, citrus2022: footnoteCitron });
export var LabelContentSpanLeft = citrusStyled.span('labelContentSpanLeft', {
    legacy: labelContentSpanLeft,
    citrus2022: labelContentSpanLeftCitron,
});
export var LabelContentSpanRight = citrusStyled.span('labelContentSpanRight', {
    legacy: labelContentSpanRight,
    citrus2022: labelContentSpanRightCitron,
});
export var LabelContentSpanTop = citrusStyled.span('labelContentSpanTop', {
    legacy: labelContentSpanTop,
    citrus2022: labelContentSpanTopCitron,
});
export var ValidationLabel = citrusStyled.em('validationLabel', {
    legacy: validationLabel,
    citrus2022: validationLabelCitron,
});
export var Styled = {
    InfoIcon: InfoIcon,
    ErrorMessage: ErrorMessage,
    Footnote: Footnote,
    Input: Input,
    Label: Label,
    LabelWrapChildren: LabelWrapChildren,
    LabelWrapChildrenSide: LabelWrapChildrenSide,
    LabelWrapperChildren: LabelWrapperChildren,
    ValueWrapper: ValueWrapper,
    CharacterCount: CharacterCount,
    LabelContentSpanLeft: LabelContentSpanLeft,
    LabelContentSpanRight: LabelContentSpanRight,
    LabelContentSpanTop: LabelContentSpanTop,
    ValidationLabel: ValidationLabel,
};
